<template>
    <text-input
      ref="input"
      :placeholder="placeholder"
      @paste.native="onPaste"
      @returned="onReturn"
      @blur="onBlur"
      @on-advanced-search="$emit('on-advanced-search')"
      v-bind:textValue="value"
      v-on:input="$emit('input', $event)"
    />
</template>
<script>
import formmixin from '@/forms/components.js';
import Utils from 'libs/utils';
import TextInput from 'components/TextInput.vue';

export default {
  mixins: [formmixin],
  props: {
    value: {
      required: true
    },
    placeholder: {
      default: function () {
        return this.$t('placeholder_search');
      }
    },
    focusOnMount: {
      default: false
    },
  },
  components: {
    'text-input': TextInput,
  },
  mounted() {
    if(this.focusOnMount) this.setFocus();
  },
  methods: {
    setFocus() {
      this.$refs.input.focus();
      this.$refs.input.select();
    },
    unfocus(){
      this.$refs.input.blur();
    },
    onReturn(){
      this.stripAndEmit(this.value);
      this.$emit('search');
    },
    onPaste(e) {
      if(Utils.isBarcode(e.clipboardData.getData('text/plain')))
      {
        e.preventDefault();
        this.stripAndEmit(e.clipboardData.getData('text/plain'));
      }
      this.$emit('search');
    },
    onBlur() {
      if(this.value) this.stripBarcode(this.value);
    },
    stripAndEmit(data){
      const self = this;
      this.$nextTick(() =>{
        if(data){
          self.stripBarcode(data);
        }
        else self.$emit('input', null);
      }
      );
    },
    stripBarcode(value) {
      let stripped = Utils.stripBarcode(value);

      if (stripped !== value) {
        this.$emit('input', stripped);
      }
    }
  }
};
</script>
